import { useCallback } from "react";
import { notification, Space, Button } from "antd";

export const useOpenNotification = () => {
  const [api, contextHolder] = notification.useNotification();

  type NotificationType = "success" | "info" | "warning" | "error";

  const openNotification = useCallback(
    (type: NotificationType, description: string) => {
      api[type]({
        message: "",
        description,
        style: { padding: '26px', width: '400px' },
      });
    },
    [api],
  );

  const openNotificationWithAlert = useCallback(
    (type: NotificationType,
      description: string,
      message?: string,
      onAccept?: () => void,
      onCancel?: () => void
    ) => {
      const key = `alertNotification${Date.now()}`; // Unique key for the notification
      api[type]({
        key,
        message,
        description: (
          <div>
            <div style={{ marginBottom: 12 }}>{description}</div>
            <Space>
              <Button
                size="small"
                type="primary"
                onClick={() => {
                  onAccept?.();
                  api.destroy(key);
                }}
              >
                Refresh
              </Button>
              <Button
                size="small"
                danger
                ghost
                onClick={() => {
                  onCancel?.();
                  api.destroy(key);
                }}
              >
                Cancel
              </Button>
            </Space>
          </div>
        ),
        duration: 0, // Keep the notification open until manually closed
        placement: "topRight",
        style: { zIndex: 9999, width: 400 },
      });
    },
    [api]
  );

  return { openNotification, openNotificationWithAlert, contextHolder };
};
